module.exports = __webpack_public_path__ + "static/media/fedpa-vial.eba5a4cd.svg";